import { render, staticRenderFns } from "./highlighted-video-cmp.vue?vue&type=template&id=918abf2e&scoped=true&functional=true"
import script from "./highlighted-video-cmp.vue?vue&type=script&lang=js"
export * from "./highlighted-video-cmp.vue?vue&type=script&lang=js"
import style0 from "./highlighted-video-cmp.vue?vue&type=style&index=0&id=918abf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "918abf2e",
  null
  
)

export default component.exports